import Block from 'shopper/components/Block';

import TopbarBottom from './TopbarBottom';
import TopbarMain from './TopbarMain';

import TOPBAR from 'constants/topbar';

const TopbarMobile = () => (
  <Block position="relative" display={['block', null, null, 'none']}>
    <TopbarMain gaEventCategory={TOPBAR.GA_EVENT_CATEGORY} />
    <TopbarBottom />
  </Block>
);

export default TopbarMobile;
